import { render, staticRenderFns } from "./AttendencePlaceAddModal.vue?vue&type=template&id=51eb04d0"
import script from "./AttendencePlaceAddModal.vue?vue&type=script&lang=js"
export * from "./AttendencePlaceAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports